// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { HttpService } from './../../../core/services/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { API_KEY } from '@app/core/environment.configuration';
import { Group, GroupDetail } from '../models/groups.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GroupsService {
  readonly urls = {
    groups: () => `${this.api}/groups`,
    group: (id: string) => `${this.api}/groups/${id}`,
    groupUsers: (groupId: string) => `${this.api}/groups/${groupId}/users`,
    groupUser: (groupId: string, userGroupId: string) => `${this.api}/groups/${groupId}/users/${userGroupId}`
  };

  constructor(private httpClient: HttpClient, @Inject(API_KEY) private api: string, private httpService: HttpService ) {}

  public getList(): Observable<Group[]> {
    return this.httpClient.get<Group[]>(this.urls.groups()).pipe(map((response: GroupsListResponse) => response.groups));
  }

  public get(id: string): Observable<GroupDetail> {
    return this.httpClient.get<GroupDetail>(this.urls.group(id));
  }

  public createGroup(request: CreateGroupRequest) {
    return this.httpClient.post(this.urls.groups(), request);
  }

  public updateGroup(groupId: string, request: CreateGroupRequest) {
    return this.httpClient.put(this.urls.group(groupId), request);
  }

  public deleteGroup(groupId: string) {
    return this.httpClient.delete(this.urls.group(groupId));
  }

  public getUsersFromGroup(groupId: string) {
    return this.httpClient.get(this.urls.groupUsers(groupId));
  }

  public addUserToGroup(groupId: string, request: AddUserToGroupRequest) {
    return this.httpClient.post(this.urls.groupUsers(groupId), request);
  }

  public deleteUserFromGroup(groupId: string, userGroupId: string) {
    return this.httpClient.delete(this.urls.groupUser(groupId, userGroupId));
  }

  public getGroupUsers (groupId: string): Observable<GroupUser[]> {
    return this.httpService.get(this.httpService.urls.groups.groupUsers, { urlParam: groupId});
  }
}

export interface CreateGroupRequest {
  group_name: string;
  description: string;
  account_id?: string;
}

export interface AddUserToGroupRequest {
  usernames: string[];
}

interface GroupsListResponse {
  groups: Group[];
}

// Response from /groups/groupId/users
export interface GroupUser {
  user_group_id: string;
  group_id: string;
  username: string;
  created_at: number;
  updated_at: number;
  created_by: string;
  updated_by: string;
}



// WEBPACK FOOTER //
// ./src/app/access-management/core/services/group.service.ts